export default class FoulingConfigData {
    constructor(
        foulingMethod,
        foulingAdjusted
    ) {
        this.foulingMethod = foulingMethod;
        this.foulingAdjusted = foulingAdjusted;
    }
} 